/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */

import React from 'react';
import { motion } from 'framer-motion';
import lang from '../../assets/images/lang.svg';
import framework from '../../assets/images/framework.svg';
import skill from '../../assets/images/skill.svg';
import Resume from '../CTA';
import './index.css';

const About = () => {
  const fadeAnimation = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.section id="about" className="container" initial="hidden" animate="visible" variants={fadeAnimation}>
      <p className="about-p">Get To Know</p>
      <h1>About Me</h1>

      <div className="about_container">
        <motion.div className="cards" initial="hidden" animate="visible" variants={fadeAnimation}>
          <motion.div className="languages card" variants={fadeAnimation}>
            <img className="img-about" src={lang} alt="languages" />
            <h3>Languages</h3>
            <ul>
              <li>JavaScript (ES6+)</li>
              <li>HTML</li>
              <li>CSS</li>
              <li>Ruby</li>
            </ul>
          </motion.div>
          <motion.div
            className="frameworks card"
            variants={fadeAnimation}
          >
            <>
              <img className="img-about" src={framework} alt="framewoks" />
              <h3>Frameworks</h3>
              <ul>
                <li>React.js</li>
                <li>Bootstrap</li>
                <li>Tailwind</li>
                <li>Ruby on Rails</li>
              </ul>
            </>
          </motion.div>
          <motion.div
            className="softSkill card"
            variants={fadeAnimation}
          >
            <img className="img-about" src={skill} alt="skills" />
            <h3>Soft Skills</h3>
            <ul>
              <li>Git</li>
              <li>Github</li>
              <li>Testing</li>
              <li>Communication</li>
              <li>Problem Solving</li>
              <li>Team Collaboration</li>
            </ul>
          </motion.div>
        </motion.div>

        <motion.div className="about_me" initial="hidden" animate="visible" variants={fadeAnimation}>
          <p>
            I have invested considerable time in remote development, showcasing my skills in both backend and frontend. Achieving a 97% average in my capstone evaluation reflects my ability to work intelligently, competing closely with the top-performing students at the national level. This success underscores my capacity to excel in demanding situations and work smartly to achieve goals.
          </p>

          <p>
            I have tackled diverse projects, from crafting landing pages to using APIs, highlighting my technical proficiency and adaptability. I prioritize efficiency, believing in completing work well before deadlines. In the last few months, I have worked remotely across three different time zones (UTC-6, UTC+1, UTC+5), emphasizing my adaptability and resilience in challenging environments.
            In my free time, I enjoy reading books, watching movies.
          </p>
          <Resume />
        </motion.div>
      </div>
    </motion.section>
  );
};

export default About;
